import { Button, Grid, TextField } from '@mui/material';
import React from 'react';
import { GetAuth } from './Auth/AuthProvider';
import Logo from './components/shared/Logo';
import MultiClick from './components/shared/MultiClick';

export default function LoginForm() {
  const auth = GetAuth();
  const [credentials, setCredentials] = React.useState({});

  const submitLogin = () => {
    auth.SignIn(credentials.username, credentials.password, loginCallback);
  };

  const handleEnterKeyDown = (event) => {
    if (event.key === 'Enter') {
      submitLogin();
    }
  };

  const loginCallback = ({ status, message }) => {
    if (status === true) {
      auth.Notification('Authenticated', 'success');
      auth.setPermissions({ LoggedIn: true });
    } else {
      auth.Notification(message, 'error');
    }
  };

  if (localStorage.getItem('JWT_Key')) {
    // console.log(localStorage.getItem('Technician'));
    const userPath =
      // localStorage.getItem('Technician') === 'true'
      localStorage.getItem('type') === 'technician'
        ? auth.navigateTo('/tech/timeandattendance', true)
        : auth.navigateTo('/', true);
    return userPath;
  } else {
    return (
      <>
        <Grid item xs={3} onKeyDown={handleEnterKeyDown}>
          <Grid
            container
            spacing={0}
            direction='column'
            alignItems='center'
            justifyContent='center'
            style={{ minHeight: '100vh' }}
          >
            <MultiClick />
            <TextField
              label='username'
              variant='outlined'
              sx={{ marginTop: '20px', width: '300px' }}
              onChange={(event) => {
                setCredentials((c) => {
                  let n = c;
                  n.username = event.target.value;
                  return n;
                });
              }}
            />
            <TextField
              label='password'
              type='password'
              variant='outlined'
              sx={{ marginTop: '20px', width: '300px' }}
              onChange={(event) => {
                setCredentials((c) => {
                  let n = c;
                  n.password = event.target.value;
                  return n;
                });
              }}
            />
            <Button
              size='large'
              variant='contained'
              color='info'
              sx={{ marginTop: '10px', marginBottom: '10px' }}
              onClick={submitLogin}
            >
              Login
            </Button>
          </Grid>
        </Grid>
      </>
    );
  }
}
